import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@fortawesome/fontawesome-free/css/all.css';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: '#9C27B0',
            secondary: '#b0bec5',
            info: '#007BFF',
            success: '#4CAF50',
            background: '#EEEEEE',
            warning: '#FF9800',
            danger: '#F44336',
            default :  '#999999',
            rose: '#E91E63' 
          },
          dark: {
            primary: '#9C27B0',
            secondary: '#b0bec5',
            info: '#007BFF',
            success: '#4CAF50',
            background: '#EEEEEE',
            warning: '#FF9800',
            danger: '#F44336',
            default :  '#999999',
            rose: '#E91E63'
          }
        },
      }
});
